* {
  box-sizing: border-box;
}

.modal {
  .modal-overlay {
    background: #000;
    opacity: 0.6;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 13;
  }

  button {
    background: #fff;
    border: 2px solid #0076c0;
    padding: 15px 20px;
    color: #0076c0;
    z-index: 15;
    position: fixed;
    right: 0;
    top: 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    z-index: 99;

    &:hover {
      background:#0076c0;
      color: #fff;
    }
  }

  .modal-content {
    background: #fff;
    max-width: 600px;
    width: 100%;
    padding: 64px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 15;
  }

  &.modal-video {
    button {
      background: #000;
      border: 2px solid #000;
      padding: 15px 20px;
      color: #fff;
      z-index: 16;
    }

    .modal-content {
      background: #fff;
      max-width: 100%;
      height: 100%;
      padding: 0;

      .zento-video {
        height: 100%;
        width: 100%;

        video {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .modal {
    &.modal-video {
      .modal-content {
        height: auto;
      }
    }
  }
}

@media (max-width: 639px) {
  .modal {
    .modal-content {
      padding-left: 32px;
      padding-right: 32px;
    }
  }
}

@media (max-width: 479px) {
  .modal {
    .modal-content {
      padding-left: 24px;
      padding-right: 24px;
    }
  }
}
